import {
  TypeLink_externalFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import { Asset, Entry } from 'contentful';

export enum HOMEPAGE_REDESIGN_IDS {
  SCIENCE_BEHIND = 'scienceBehind',
  MORE_TO_LOVE = 'more_to_love',
  UGC = 'ugc',
  OBSESSION_VIDEO = 'obsession',
  SIDE_BY_SIDE = 'sideBySide',
  EMAIL_CAPTURE = 'emailCapture',
  SOCIAL_PROOF = 'socialproof',
  EXPERIMENT_TRANSLATIONS = 'experimentTranslations',
}

export type homepageRedesignTranslations = {
  title: string;
  subtitle: string;
  firstItem: string;
  secondItem: string;
  no_subheading: string;
  subheading_single_line: string;
  heading_desktop: string;
  heading_mobile: string;
  subheading_experiment: string;
  playkits_by_age_heading: string;
};

export type scienceBehindModuleTranslations = {
  title: string;
  item1Heading: string;
  item1Label: string;
  item2Heading: string;
  item2Label: string;
  item3Heading: string;
  item3Label: string;
};

export type obsessionVideoSideBySideTranslations = {
  title: string;
  item1: string;
  item2: string;
  item3: string;
};

export type ImagesWithCta = {
  images: Asset[];
  t: Entry<Record<string, any>>;
  CTAs?: Array<Entry<TypeLink_externalFields | TypeLink_internalFields>>;
};
